import React, { memo } from 'react';

const SecurityLock = ({ ...props }) => {
    return (
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42 25h-3v-3c0-5-4-7-7-7s-7 2-7 7.083V25h-3c-1.558 0-3 1.442-3 3l2 13.917C21 43.475 30.442 50 32 50c1.558 0 11-6.525 11-8.083L45 28c0-1.558-1.442-3-3-3zM32 39c-1.558 0-3-1.442-3-3s1.442-3 3-3 3 1.442 3 3-1.442 3-3 3zm4-14h-8.058v-2.917C27.942 19.661 29.5 18 32 18s4 1.66 4 4.083V25z"
                fill="#A9B1B9"
            />
            <circle cx="32" cy="32" r="31" stroke="#A9B1B9" strokeWidth="2" />
        </svg>
    );
};

export default memo(SecurityLock);
